import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
// import styled from 'styled-components';
import { Redirect, withRouter } from 'react-router-dom';

import { makeSelectUser } from 'containers/User/selectors';
import { connect } from 'react-redux';
import { StripeProvider } from 'react-stripe-elements';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import Config from '../../app.config';
import EligibleRoute from './EligibleRoute';
import { isNil } from 'lodash-es';
import { NOT_ALLOWED_ROUTES_IMPERSONATE_USER } from '../../utils/common';
import PageNotAllowed from '../../components/ErrorBoundary/page-not-allowed';

class PrivateRoute extends React.PureComponent {
  render() {
    const {
      component: Component,
      user,
      location,
      toPath,
      injectStripe,
      eligibleOnly,
      bothEligibleOnlyAndInjectStripe,
      ...rest
    } = this.props; // eslint-disable-line react/prop-types    
    
    const isEligible = this.props.appointmentData &&  bothEligibleOnlyAndInjectStripe && !this.props.appointmentData.fetchingStatus && this.props.appointmentData.myStatus && this.props.appointmentData.myStatus.hasCompletedAppointments;

    const isImpersonateUser = isNil(localStorage.getItem('impersonateUser'))
      ? false
      : localStorage.getItem('impersonateUser') === 'true';

    if (
      isImpersonateUser &&
      NOT_ALLOWED_ROUTES_IMPERSONATE_USER.includes(rest.path)
    ) {
      return <PageNotAllowed />;
    }

    if (!user.userData.id) {
      return (
        <Redirect
          to={{
            pathname: toPath || '/register',
            search: location.search,
            state: { from: this.props.location }, // eslint-disable-line react/prop-types
          }}
        />
      );
    }

    if (isEligible) {
      return (
        <StripeProvider apiKey={Config.stripeApiKey}>
          <EligibleRoute {...rest} component={Component} />
        </StripeProvider>
      );
    }

    if (injectStripe) {
      return (
        <StripeProvider apiKey={Config.stripeApiKey}>
          <Component {...rest} />
        </StripeProvider>
      );
    }
    return eligibleOnly ? (
      <EligibleRoute {...rest} component={Component} />
    ) : (
      <Component {...rest} />
    );
  }
}

PrivateRoute.propTypes = {
  component: PropTypes.func,
  user: PropTypes.object,
  location: PropTypes.object,
  toPath: PropTypes.object,
  injectStripe: PropTypes.func,
  eligibleOnly: PropTypes.bool,
};

const mapStateToProps = createStructuredSelector({
  user: makeSelectUser(),
});
const withConnect = connect(mapStateToProps);

export default compose(
  withRouter,
  withConnect,
)(PrivateRoute);
